export default {
  'lock.title': 'Your Session is locked',
  'lock.username': 'Username',
  'lock.password': 'Password',
  'lock.question': 'Are you not John Doe ?',
  'lock.unlock': 'Unlock',
};
